import React from 'react'
import { Grid, Row, Col } from 'react-bootstrap'

export default ({ delivery, removeDelivery }) => {
    console.log(delivery)

    return (
        <Grid fluid>
            <Row>
                <Col xs={12} md={2} lg={2}>
                    <p>Från {delivery.sender.name}</p>
                </Col>

                <Col xs={12} md={2} lg={2}>
                    <p>Till person: {delivery.receiver.displayName}</p>
                </Col>

                <Col xs={12} md={2} lg={2}>
                    <p>Till företag: {delivery.receiver.name} - {delivery.receiver.custom_name}, {delivery.receiver.address1}</p>
                </Col>

                <Col xs={12} md={2} lg={2}>
                    <p>Paketid: {delivery.delivery.packageId}</p>
                </Col>

                <Col xs={12} md={2} lg={2}>
                    <p>Transportör: {delivery.carrierName}</p>
                </Col>

                <Col xs={12} md={2} lg={2}>
                    <button onClick={e => removeDelivery(delivery.delivery.packageId)}>X</button>
                </Col>
            </Row>

        </Grid>
    )
}

